import 'whatwg-fetch';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import * as React from 'react';
import { Route } from 'react-router';
import { ROOT_INDEX } from '../constants/routes';
import Main from './main';
import AppProviders from './providers/AppProviders';
import { HashRouter } from 'react-router-dom';

dayjs.extend(utc);

export function App() {
  return (
    <HashRouter>
      <AppProviders>
        <Route path={ROOT_INDEX} component={Main} />
      </AppProviders>
    </HashRouter>
  );
}
